/* RONCADOR: espaco entre letras e peso no padrao da Apple.
   Para cada texto da pagina le o tamanho da letra e aplica:
     - o espaco entre letras da tabela da Apple para aquele tamanho;
     - SF Pro Display nos textos de 20px para cima;
     - peso 400 ou 600 (a Apple so usa esses dois).
   Roda ao abrir a pagina e de novo quando entra conteudo novo (carrinho,
   troca de pagina sem recarregar, filtros). */
(function () {
  if (window.__rcFonteApple) return;
  window.__rcFonteApple = true;

  /* tamanho -> espaco entre letras (px), medido no apple.com/br */
  var TABELA = [
    [10, -0.05], [11, -0.06], [12, -0.12], [13, -0.172], [14, -0.224], [15, -0.274],
    [16, -0.32], [17, -0.374], [18, -0.424], [19, 0.228], [20, 0.234], [21, 0.231],
    [24, 0.216], [28, 0.196], [32, 0.128], [40, 0], [48, -0.144], [56, -0.28], [64, -0.32], [80, -0.4]
  ];
  var TITULO = "-apple-system, BlinkMacSystemFont, 'SF Pro Display', Inter, 'Helvetica Neue', Helvetica, Arial, sans-serif";

  function espaco(t) {
    if (t <= TABELA[0][0]) return TABELA[0][1];
    for (var i = 1; i < TABELA.length; i++) {
      var a = TABELA[i - 1];
      var b = TABELA[i];
      if (t <= b[0]) {
        /* entre 18 e 19 a Apple troca de Text para Display: sem meio-termo */
        if (a[0] === 18) return t < 18.5 ? a[1] : b[1];
        return a[1] + ((b[1] - a[1]) * (t - a[0])) / (b[0] - a[0]);
      }
    }
    return TABELA[TABELA.length - 1][1];
  }

  var feitos = new WeakMap();
  function temTexto(el) {
    for (var n = el.firstChild; n; n = n.nextSibling) {
      if (n.nodeType === 3 && n.nodeValue.trim()) return true;
    }
    return false;
  }
  function ajustar(el) {
    if (!el.style || el.closest('svg, .rc-fonte-livre')) return;
    if (!temTexto(el) && !/^(INPUT|TEXTAREA|SELECT|BUTTON)$/.test(el.tagName)) return;
    var s = getComputedStyle(el);
    var t = parseFloat(s.fontSize) || 16;
    var chave = t + '|' + s.fontWeight;
    if (feitos.get(el) === chave) return;
    var w = parseInt(s.fontWeight, 10) || 400;
    var novoPeso = w >= 650 ? 600 : w <= 550 ? 400 : w;
    if (novoPeso !== w) el.style.setProperty('font-weight', String(novoPeso), 'important');
    el.style.setProperty('letter-spacing', espaco(t).toFixed(3) + 'px', 'important');
    if (t >= 19) el.style.setProperty('font-family', TITULO, 'important');
    feitos.set(el, t + '|' + getComputedStyle(el).fontWeight);
  }
  function passar(raiz) {
    if (!raiz || raiz.nodeType !== 1) return;
    ajustar(raiz);
    var todos = raiz.getElementsByTagName('*');
    for (var i = 0; i < todos.length; i++) ajustar(todos[i]);
  }

  var fila = [];
  var agendado = false;
  function agendar(el) {
    fila.push(el);
    if (agendado) return;
    agendado = true;
    (window.requestIdleCallback || setTimeout)(function () {
      agendado = false;
      var lista = fila;
      fila = [];
      lista.forEach(function (e) {
        if (document.body.contains(e)) passar(e);
      });
    }, { timeout: 300 });
  }

  function iniciar() {
    passar(document.body);
    new MutationObserver(function (muds) {
      muds.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) agendar(n);
          else if (n.nodeType === 3 && n.parentElement) agendar(n.parentElement);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
    /* fontes carregadas depois mudam medidas: passa de novo uma vez */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        passar(document.body);
      });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
